<template>
	<IsBusyScreenComponent v-if="isBusyCarCalcsBO" />
	<Panel
		title="Buyer's Order"
		class="panel-buyers-order"
	>
		<template #header>
			<div class="panel-buttons">
				<div
					v-if="bo && user.isAdmin"
					class="bo-transaction-id"
				>
					<div class="bo-transaction-active">
						<div class="bo-transaction-id-title">BO Active:</div>
						<div class="bo-transaction-id-value">{{ bo.transactionId }}</div>
					</div>
					<div class="bo-transaction-last">
						<div class="bo-transaction-id-title">Last Sent:</div>
						<div class="bo-transaction-id-value">
							{{ bo.lastTransactionId }}
						</div>
					</div>
				</div>
				<!-- <span v-if="bo && user.isAdmin" class="bo-transaction-id"></span> -->
				<button
					:disabled="fimenu.buyersOrderIsBusy || anyBookValueInvalid"
					@click="reset()"
					:class="{
						'button button-edit': true,
						pulsing: !fimenu.buyersOrderIsBusy && fimenu.buyersOrderUpdateRequired,
					}"
				>
					<i class="fas fa-sync" /> Reset
				</button>
				<ButtonSubmitToFinanceInstitutions
					v-if="submitToFinanceChannel"
					:deal="fimenu"
				/>
			</div>
		</template>
		<!--<PanelMSVehicles :fimenu="fimenu" v-if="mscanAccount != null" :mscanAccount="mscanAccount"></PanelMSVehicles>
        <PanelRebates :fimenu="fimenu" :validation="validation" :mscanAccount="mscanAccount"></PanelRebates>-->

		<div class="additional-amounts">
			<BuyersOrderRow>
				<template #info>
					<span>Deal Type</span>
				</template>
				<template #column-3>
					<InputRichDropdown
						v-model:saturn="fimenu.dealType"
						:list="dealTypes"
						@change="dealTypeChanged()"
						:invalid="!fimenu.dealType"
						cssClass="deal-type-dropdown"
					>
						<template #validation>
							<div v-if="!fimenu.dealType">Deal Type is required</div>
						</template>
					</InputRichDropdown>
				</template>
			</BuyersOrderRow>

			<BuyersOrderRow>
				<template #info>
					<span>Miles Per Year</span>
				</template>

				<template #column-3>
					<InputNumber
						v-model:saturn="fimenu.vehicle.milesPerYear"
						:precision="0"
						:invalid="util.isNull(fimenuValidation) ? false : fimenuValidation.vehicle.milesPerYear.$invalid"
						@blur="() => saveLockedDeal(util.isNull(fimenuValidation) ? false : fimenuValidation.vehicle.milesPerYear.$invalid)"
						:min="0"
					>
						<template #validation>
							<div v-if="!util.isNull(fimenuValidation) && !fimenuValidation.vehicle.milesPerYear.required">Miles Per Year is required</div>
						</template>
					</InputNumber>
				</template>
			</BuyersOrderRow>

			<BuyersOrderRow v-if="fimenu.isLease()">
				<template #info>
					<span>One Pay Lease</span>
				</template>
				<template #column-2>
					<div class="align-right">
						<InputCheckbox
							v-model="fimenu.isOnePayLease"
							:useSquare="true"
							@click="recalculate()"
							title="Enable/Disable One Pay Lease"
						>
						</InputCheckbox>
					</div>
				</template>
				<template #column-3>
					<InputCurrency
						label="Pay Amt"
						:saturn="fimenu.onePayLeaseAmount()"
						:precision="2"
						:disabled="true"
						placeholder="N/A"
					/>
				</template>
			</BuyersOrderRow>

			<BuyersOrderRow v-if="fimenu.isFinance()">
				<template #info>
					<span>Max Days to 1st Payment</span>
				</template>

				<template #column-3>
					<InputNumber
						v-model:saturn="fimenu.loanTerms.maxDaysToFirstPayment"
						placeholder="Days"
						:precision="0"
						:isPercent="false"
						:invalid="fimenuValidation?.loanTerms.maxDaysToFirstPayment.$invalid ?? v$.deal?.loanTerms.maxDaysToFirstPayment.$invalid"
						@change="recalculate()"
					>
						<template
							#validation
							v-if="fimenuValidation?.loanTerms.maxDaysToFirstPayment.$invalid || v$.deal?.loanTerms.maxDaysToFirstPayment.$invalid"
						>
							<div v-if="fimenuValidation?.loanTerms.maxDaysToFirstPayment">
								<span
									v-for="error in fimenuValidation?.loanTerms.maxDaysToFirstPayment.$silentErrors"
									:key="error.$message"
								>
									{{ error.$message }}
								</span>
							</div>
							<div v-else-if="v$.deal?.loanTerms.maxDaysToFirstPayment">
								<span
									v-for="error in v$.deal?.loanTerms.maxDaysToFirstPayment.$silentErrors"
									:key="error.$message"
								>
									{{ error.$message }}
								</span>
							</div>
						</template>
					</InputNumber>
				</template>
			</BuyersOrderRow>

			<BuyersOrderBookValues
				:vehicle="fimenu.vehicle"
				bucketType="Vehicle Values"
				addNewItemPrompt="Add"
				:isVehicleNew="fimenu.isNew()"
				:validation="fimenuValidation"
				@editBookValueClick="handleEditBookValue"
				@addBookValueClick="handleAddBookValue"
			/>
		</div>
		<div
			v-if="bookValuesValidationMessages"
			class="bo-placeholder"
		>
			<h4 v-if="bookValuesValidationMessages">
				{{ bookValuesValidationMessages.Message }}
			</h4>
		</div>
		<div
			v-else-if="!canDisplayBO"
			class="bo-placeholder"
		>
			<h4>Missing values to generate Buyer's Order</h4>
		</div>
		<IsBusySectionComponent v-else-if="fimenu.buyersOrderIsBusy" />
		<div v-else-if="bo">
			<div class="buyers-order-grid fade-in-fast">
				<div
					v-if="bo.isError()"
					class="buyers-order-grid fade-in-fast panel-body"
				>
					<div class="buyers-order-error">
						<div class="buyers-order-error-title">Buyers Order Error</div>
						<div class="buyers-order-error-subtitle">An error has occurred generating a buyers order. Verify all the information entered is correct.</div>

						<div class="buyers-order-error-code">{{ bo.errorCode }}</div>
						<div class="buyers-order-error-message">{{ bo.errorMessage }}</div>

						<div class="buyers-order-error-actions">
							<div><br />You can fix the issue above and click RESET, or you can create the buyers order manually.</div>

							<div class="buyers-order-error-manual-button">
								<button @click="createEmptyBuyersOrder()">Manual Buyers Order</button>
							</div>
						</div>
					</div>
				</div>

				<div
					v-else
					class="bo-body"
				>
					<BuyersOrderRow class="buyers-order-column-headers">
						<template #right-icon><span></span></template>
						<template #column-1>Amount</template>
						<template #column-2>Cost</template>
						<template #column-3>Profit</template>
					</BuyersOrderRow>

					<BuyersOrderRow>
						<template #left-icon>
							<span
								v-if="bo.isLease()"
								class="buyers-order-upfront-capped-icon"
							>
								<Pill
									label="C"
									status="warning"
									:size="10"
									:includeDot="false"
								/>
							</span>
						</template>

						<template #info>
							<div>Selling Price</div>

							<!-- <div class="rollup-container">
                                <Pill
                                    v-if="bo.isSellingPriceTaxed()"
                                    label="Taxed"
                                    status="warning"
                                    :size="10"
                                    :includeDot="false"
                                />
                            </div> -->
						</template>

						<template #right-icon>
							<span>+</span>
						</template>

						<template #column-1>
							<InputCurrency
								v-model:saturn="bo.sellingPrice"
								:modelValue="bo.sellingPrice"
								@change="recalculate()"
								placeholder="Selling Price"
								:precision="2"
								iconSide="left"
								:invalid="v$.bo.sellingPrice.$invalid"
							>
								<template #validation>
									<div v-if="v$.bo.sellingPrice.required.$invalid">Selling Price is required</div>
									<div v-if="v$.bo.sellingPrice.minValue.$invalid">Selling Price amount invalid.</div>
								</template>
							</InputCurrency>
						</template>

						<template #column-2>
							<InputCurrency
								v-model:saturn="bo.invoiceAmount"
								class="ignore-deal-lock"
								iconSide="left"
								:precision="2"
								:disabled="isInvoiceAmountDisabled"
								:invalid="v$.bo.invoiceAmount.$invalid"
								@blur="() => saveLockedDeal(v$.bo.invoiceAmount.$invalid)"
								@change="() => recalculate(fimenu.isDealLocked())"
							>
								<template #validation>
									<div v-if="v$.bo.invoiceAmount.required.$invalid">Actual cost is required</div>
									<div v-if="v$.bo.invoiceAmount.minValue.$invalid">Actual cost amount invalid.</div>
								</template>
							</InputCurrency>
						</template>

						<template #column-3>
							<InputCurrency
								:saturn="bo.sellingPriceProfit()"
								:precision="2"
								iconSide="left"
								:disabled="true"
							>
							</InputCurrency>
						</template>
					</BuyersOrderRow>

					<fieldset
						class="buyers-order-content"
						:disabled="isBusyAddEdit"
					>
						<BuyersOrderBucket
							:bo
							:fimenu
							:sourceData="fimenu.tradeIns"
							bucketType="Trades"
							@change="() => recalculate(fimenu.isDealLocked())"
							:costLockCondition="() => fimenu.lockByDealStatus() || fimenu.isDealFinalized()"
							@blur="(isInvalid: boolean) => saveLockedDeal(isInvalid)"
						/>
						<BuyersOrderBucket
							:bo
							:fimenu
							bucketType="Products"
							@change="() => recalculate(fimenu.isDealLocked())"
							@addEditItemClick="addEditItem"
							addNewItemPrompt="Manage Preloads"
							:showItems="true"
							:costLockCondition="() => fimenu.isDealLocked() || fimenu.isDealPassedFinance()"
						/>
						<BuyersOrderBucket
							:bo
							:fimenu
							bucketType="Fees"
							@change="() => recalculate(fimenu.isDealLocked())"
							@addEditItemClick="addEditItem"
							addNewItemPrompt="Add New Fee"
							:costLockCondition="() => fimenu.isDealFinalized()"
							:slotContainerProperties="getSlotNames()"
						>
							<template #1115>
								<div></div>
								<div>Security Deposit Amount</div>
								<InputNumber
									v-model:saturn="bo.security.refundableSecurityDepositCount"
									iconSide="left"
									:disabled="!selectedLenderVersion"
									@change="calculateSecurityDepositAmount"
									:min="0"
								>
								</InputNumber>
								<div></div>
								<InputCurrency
									:saturn="bo.security.refundableSecurityDepositAmount"
									:precision="2"
									iconSide="left"
									disabled
									:min="0"
								>
								</InputCurrency>
							</template>
						</BuyersOrderBucket>
						<BuyersOrderBucket
							:bo
							:fimenu
							bucketType="Additions"
							@change="() => recalculate(fimenu.isDealLocked())"
							@addEditItemClick="addEditItem"
							addNewItemPrompt="Add New Addition"
							:costLockCondition="() => fimenu.isDealFinalized()"
						/>
						<BuyersOrderBucket
							:bo
							:fimenu
							bucketType="Rebates"
							@change="() => recalculate(fimenu.isDealLocked())"
							@addEditItemClick="addEditItem"
							addNewItemPrompt="Add New Rebate"
							:costLockCondition="() => fimenu.isDealPassedFinance()"
						/>
						<BuyersOrderBucket
							:bo
							:fimenu
							bucketType="Cash Down"
							@change="() => recalculate(fimenu.isDealLocked())"
							@addEditItemClick="addEditItem"
							addNewItemPrompt="Add Payment"
							:costLockCondition="() => fimenu.hasPaperworkPacket()"
							:fimenuValidation
						/>
						<BuyersOrderTaxesTotal
							:bo
							:isAddTaxLineDisabled="fimenu.isDealLocked() || fimenu.isDealPassedFinance()"
							@addEditTaxLineClick="addEditTaxLine"
						/>

						<!-- Accounting Adjustments -->
						<BuyersOrderBucket
							:bo
							:fimenu
							bucketType="Adjustments"
							@change="() => recalculate(fimenu.isDealLocked())"
							@addEditItemClick="addEditItem"
							addNewItemPrompt="Add New Adjustment"
							:costLockCondition="() => !isUserInAccounting"
						/>
					</fieldset>

					<BuyersOrderFirstPayment
						v-if="bo.isLease()"
						:bo
					/>

					<BuyersOrderRow class="subtotal-container">
						<template #info>
							<button
								v-if="$global.isAdminView"
								class="button-link subtotal-container ignore-all-locks"
								@click="showFinalNumbers(finalizing)"
							>
								Total Out the Door<span v-if="finalizing"> w/ CarCalcs</span>
							</button>
							<span
								v-else
								class="subtotal-container"
								>Total Out the Door</span
							>
						</template>

						<template #right-icon>
							<span></span>
						</template>

						<template #column-1>
							<InputCurrency
								:saturn="bo.finalNumbers.total"
								:disabled="true"
								:precision="2"
								iconSide="left"
								:negative="true"
							>
							</InputCurrency>
						</template>
						<template #column-2>
							<InputCurrency
								:saturn="bo.finalNumbers.totalCost"
								:disabled="true"
								:precision="2"
								iconSide="left"
								:negative="true"
							>
							</InputCurrency>
						</template>
						<template #column-3>
							<InputCurrency
								:saturn="bo.finalNumbers.totalProfit"
								:disabled="true"
								:precision="2"
								iconSide="left"
								:negative="true"
							>
							</InputCurrency>
						</template>
					</BuyersOrderRow>

					<BuyersOrderFinanceChargeFees
						v-if="financeChargeFees.length"
						:financeChargeFees
						:addEditItem="addEditFinanceChargeFee"
					/>

					<template v-if="bo.isLease()">
						<br /><br />

						<BuyersOrderRow>
							<template #info>
								<span
									v-if="bo.finalNumbers.leaseFinalNumbers.capCostReduction <= 0"
									class="subtotal-container"
									>Inception Deficiency</span
								>
								<span
									v-else
									class="subtotal-container"
									>Cap Cost Reduction</span
								>
							</template>

							<template #right-icon>
								<span></span>
							</template>

							<template #column-3>
								<InputCurrency
									:saturn="Math.abs(bo.finalNumbers.leaseFinalNumbers.capCostReduction)"
									:disabled="true"
									:precision="2"
									iconSide="left"
									:negative="true"
								>
								</InputCurrency>
							</template>
						</BuyersOrderRow>

						<BuyersOrderInceptions :bo />
					</template>
					<fieldset
						class="buyers-order-content"
						:disabled="isBusyAddEdit"
					>
						<BuyersOrderFunding
							v-if="fimenu.hasPaperworkPacket"
							:fimenu
							@addEditFundingClick="addEditFunding"
						/>
					</fieldset>

					<!--<PanelRebates v-if="$global.isAdminView" :fimenu="fimenu" :validation="validation" :mscanAccount="mscanAccount"></PanelRebates>
                    <PanelDesking v-if="$global.isAdminView && mscanAccount != null" :fimenu="fimenu" :validation="validation" :mscanAccount="mscanAccount"></PanelDesking>-->
				</div>
			</div>
		</div>
	</Panel>
</template>

<script lang="ts">
	export interface IPanelBuyersOrderProps {
		fimenu: FIMenu;
		fimenuValidation?: any;
		submitToFinanceChannel?: boolean;
		finalizing?: boolean;
	}
</script>

<script lang="ts" setup>
	import { computed, inject, onBeforeUnmount, onMounted, ref } from 'vue';
	import { createBookValue, editBookValue } from '@/helpers/fimenu-vehicle-helper';
	import { required, minValue } from '@vuelidate/validators';
	import util, { EventBusCore } from '@core/services/util';
	import $modal from '@core/services/modal';
	import api from '@core/services/api/_api';
	import auth from '@core/services/auth';
	import { buyersOrderHelper } from '@core/helpers/buyers-order-helper';
	import { getValidationForBookValues } from '@/helpers/fimenu-vehicle-helper';
	import settings from 'settings';

	import modalAddEditAddition from '@/modals/modalAddEditAddition.vue';
	import modalAddEditDownPayment from '@/modals/modalAddEditDownPayment.vue';
	import modalAddEditFee from '@/modals/modalAddEditFee.vue';
	import modalAddEditFinanceChargeFee from '@/modals/modalAddEditFinanceChargeFee.vue';
	import modalAddEditPreloads from '@/modals/modalAddEditPreloads.vue';
	import modalAddEditRebate from '@/modals/modalAddEditRebate.vue';
	import modalAddEditTaxLine from '@/modals/modalAddEditTaxLine.vue';
	import modalAddEditFunding from '@/modals/modalAddEditFunding.vue';
	import modalPre from '@/modals/modalPre.vue';
	import PaymentMethodEnumsHelper from '@core/_enums/PaymentMethodEnumsHelper';
	import StoreClass from '@core/classes/Store/Store';

	//import PanelRebates from '@/components/PanelRebates.vue'
	//import PanelMSVehicles from '@/components/PanelMSVehicles.vue'
	import { DEAL_TYPES, PARTNER_CODES } from '@core/classes/Enums';
	import ButtonSubmitToFinanceInstitutions from '@/components/ButtonSubmitToFinanceInstitutions.vue';
	import BuyersOrderBookValues from '@/components/buyers-order/BuyersOrderBookValues.vue';
	import BuyersOrderBucket from '@/components/buyers-order/BuyersOrderBucket.vue';
	import BuyersOrderFinanceChargeFees from './buyers-order/BuyersOrderFinanceChargeFees.vue';
	import BuyersOrderFirstPayment from '@/components/buyers-order/BuyersOrderFirstPayment.vue';
	import BuyersOrderInceptions from '@/components/buyers-order/BuyersOrderInceptions.vue';
	import BuyersOrderRow from '@/components/buyers-order/BuyersOrderRow.vue';
	import BuyersOrderFunding from '@/components/buyers-order/BuyersOrderFunding.vue';
	import InputCurrency from '@core/components/InputCurrency.vue';
	import InputNumber from '@core/components/InputNumber.vue';
	import InputRichDropdown from '@core/components/InputRichDropdown.vue';
	import InputCheckbox from '@core/components/InputCheckbox.vue';
	import IsBusyScreenComponent from '@core/components/IsBusyScreenComponent.vue';
	import IsBusySectionComponent from '@core/components/IsBusySectionComponent.vue';
	import Panel from '@core/components/Panel.vue';
	import Pill from '@core/components/Pill.vue';
	import { SaturnGlobalPlugin } from '@core/classes/StaticClasses';

	import { IBookValueContent, IBucketContent } from '@core/_interfaces/SharedInterfaces';
	import { BookValue } from '@core/classes/SharedEnums';
	import BuyersOrderTaxesTotal from '@/components/buyers-order/BuyersOrderTaxesTotal.vue';
	import { Emitter } from 'mitt';
	import Fee from '@core/classes/Fee';
	import FIMenu from '@core/classes/FIMenu';
	import FIMenuBuyersOrder from '@core/classes/FIMenuBuyersOrder';
	import FIMenuBuyersOrderFee from '@core/classes/FIMenuBuyersOrderFee';
	import FIMenuBuyersOrderTaxGroup from '@core/classes/FIMenuBuyersOrderTaxGroup';
	import FIMenuFunding from '@core/classes/FIMenuFunding';
	import { SaturnPermissions } from '@core/classes/AccessEmployeeClass';
	import { useVuelidate } from '@vuelidate/core';
	import { VehicleBookValue } from '@core/classes/VehicleBookValue';

	// interface IPanelBuyersOrderData {
	//     bo: FIMenuBuyersOrder;
	//     isBusyAddEdit: boolean;
	//     isBusyCarCalcsBO: boolean;
	//     carCalcsBo: any;
	//     taxesIsOpen: boolean;
	//     inceptionsIsOpen: boolean;
	//     downPaymentsIsOpen: boolean;
	//     monthlyUseInfoIsOpen: boolean;
	//     mscanAccount: any;
	//     feeSourceEnumsHelper: FeeSourceEnumsHelper;
	// }

	const { fimenu, fimenuValidation, submitToFinanceChannel = false, finalizing = false } = defineProps<IPanelBuyersOrderProps>();

	const $global = inject<SaturnGlobalPlugin>('$global');
	const EventBus = inject<Emitter<any>>('EventBus');

	const user = auth.getTokenPayload();
	const dealTypes = DEAL_TYPES.toList().map(dt => dt.display);

	const bo = ref<FIMenuBuyersOrder>(null);
	const isBusyAddEdit = ref(false);
	const isBusyCarCalcsBO = ref(false);
	const carCalcsBo = ref(null);
	const mscanAccount = ref<string>(null);

	const selectedLenderVersion = computed(() => {
		if (!fimenu.lender.lenderCode) return;

		const foundLender = $global.Lenders.find(lender => lender.lenderCode === fimenu.lender?.lenderCode);
		if (!foundLender) {
			util.toastr('error', 'Getting Lender Security Deposit Amount Settings', `We are unable to match the lender code ${fimenu.lender.lenderCode}`);
			return;
		}
		return foundLender.versions.find((version: any) => version.versionLabel === fimenu.store.storeState) ?? foundLender.versions[0];
	});

	const getBookValueValidationResult = computed(() => {
		const validations = getValidationForBookValues(fimenu);
		return Object.entries(validations).find(([, validation]) => !validation.valid()) || null;
	});

	const bookValuesValidationMessages = computed(() => {
		const invalidValidation = getBookValueValidationResult.value;
		return invalidValidation ? invalidValidation[1] : null; // Return the validation object or null
	});

	const anyBookValueInvalid = computed(() => !!getBookValueValidationResult.value);

	const isInvoiceAmountDisabled = computed(() => fimenu.lockByDealStatus() || fimenu.isDealFinalized());

	const canDisplayBO = computed(() => fimenu.dealType);

	const financeChargeFees = computed<FIMenuBuyersOrderFee[]>(() => bo.value?.fees.filter((fee: Fee) => fee.isFinanceCharge) ?? []);

	const isUserInAccounting = computed(() => user.hasAccountingDepartmentAccess);

	// UNUSED:
	// const lenderDealType = computed(() => {
	//     return fimenu.isLease() ? 'lease' : fimenu.isFinance() ? 'retail' : 'draft';
	// });
	// const getInvoiceOrWholeSaleLabel = computed(() => {
	//     return fimenu.inventoryType == 'New' ? 'Invoice' : 'Wholesale';
	// });
	// const cannotDisplayBOMessage = computed(() => {
	//     if (fimenu.vehicle.bookValues.length <= 0) return 'You must have at least one vehicle value';

	//     if (fimenu.isNew() && fimenu.vehicle.bookValues.some((x: any) => x.source == BookValue.Manufacturer))
	//         return "MSRP is required. Please click 'Add' and choose 'Manufacturer' from the options.";

	//     return null;
	// });

	onMounted(async () => {
		if (fimenu.buyersOrderEnabled) {
			EventBus.on('recalculateBuyersOrder', recalculateBuyersOrderHandler);
			EventBus.on('dealUpdatedExternally', dealUpdatedExternallyHandler);
			EventBus.on('buyersOrderUpdated', loadData);
			(EventBusCore as Emitter<any>).on('buyersOrderUpdated', loadData);

			loadData();
		}
		mscanAccount.value = fimenu.store.partnerCodes.find(p => p.type === PARTNER_CODES.MSCAN_ACCOUNT)?.code;
	});

	onBeforeUnmount(() => {
		EventBus.off('recalculateBuyersOrder', recalculateBuyersOrderHandler);
		EventBus.off('dealUpdatedExternally', dealUpdatedExternallyHandler);
		EventBus.off('buyersOrderUpdated', loadData);
		(EventBusCore as Emitter<any>).off('buyersOrderUpdated', loadData);
	});

	function dealUpdatedExternallyHandler(isUpdatedExternally: boolean) {
		if (isUpdatedExternally) util.debounce(loadData, 100);
	}

	function recalculateBuyersOrderHandler() {
		console.log('recalculateBuyersOrderHandler() -> PanelBuyersOrder.vue');
		util.debounce(loadData, 100);
	}

	function getSlotNames() {
		return fimenu.isLease() ? ['1115'] : [];
	}

	async function getCarCalcBO() {
		isBusyCarCalcsBO.value = true;
		try {
			carCalcsBo.value = (await api.fimenu.getCarCalcsBuyersOrder(fimenu))?.data;
		} catch (error) {
			console.error(error);
		} finally {
			isBusyCarCalcsBO.value = false;
		}
	}

	function calculateSecurityDepositAmount() {
		if (!selectedLenderVersion.value) return;

		let roundedTo = selectedLenderVersion.value.lease?.securityDepositRoundToNearestAmount;
		if (!roundedTo) {
			util.toastr(
				'error',
				'Missing Lender Setting',
				`Lender Setting for "${fimenu.lender.lenderName}" is missing the 'Rounded Security Deposit Amount' for lease deals. Using default value of {$75} for rounding.`,
				10000,
			);
			roundedTo = 75;
		}

		//SAVE THE SETTING FROM LENDER
		bo.value.security.roundedTo = roundedTo;
		recalculate(fimenu.isDealLocked());
	}

	async function showFinalNumbers(showCarCalcs?: boolean) {
		const modalTitle = showCarCalcs ? 'Car Calcs Compare' : 'Final Numbers';
		if (showCarCalcs) await getCarCalcBO();
		const allBuyersOrders =
			carCalcsBo.value && showCarCalcs
				? {
						originalBuyersOrder: bo,
						carCalcsBuyersOrder: carCalcsBo,
						finalizing: finalizing,
					}
				: bo;

		$modal.open(modalPre, {
			name: 'modalPre',
			passedData: { title: modalTitle, data: allBuyersOrders },
			backdrop: true,
		});
	}

	function createEmptyBuyersOrder() {
		if (!bo.value) return;

		bo.value.clearAndCreateAnEmptyBuyersOrder();
		recalculate();
	}

	function handleAddBookValuePrePostFunction(newBookValues: VehicleBookValue[] = []) {
		const currentBO = fimenu.getCurrentBuyersOrder();
		const isMSRPDifferent = hasMSRPChanged(newBookValues);

		newBookValues.forEach(bv => {
			// Loop through the newly updated values.
			// Get the memory location of the value to modify.
			const bookValues = fimenu.vehicle.bookValues;
			const bookValueToUpdate = bookValues.find((x: VehicleBookValue) => x.source == bv.source);

			// If the value exists; modify its content.
			if (bookValueToUpdate) {
				bookValueToUpdate.retail = bv.retail;
				bookValueToUpdate.wholesale = bv.wholesale;
			} else {
				// If we don't find it. Lets create it?
				bookValues.push(new VehicleBookValue(bv));
			}
		});

		if (!currentBO) return loadData();

		if (isMSRPDifferent) reset();
	}

	function hasMSRPChanged(newBookValues: VehicleBookValue[] = []) {
		// Extract the current and new MSRP values
		const currentMSRP = fimenu.vehicle.bookValues.find((x: VehicleBookValue) => x.source === BookValue.Manufacturer)?.retail;
		const newMSRP = newBookValues.find(x => x.source === BookValue.Manufacturer)?.retail;

		if (!newMSRP) return false;

		// If both are undefined or equal, return early to avoid resetting unnecessarily
		if (currentMSRP === newMSRP) return false;

		// Otherwise, trigger reset logic
		return true;
	}

	function handleAddBookValue({ row }: IBookValueContent) {
		switch (row) {
			case 'Vehicle Values':
				// Opens a modal to create a book value for the specified vehicle.
				createBookValue(fimenu.vehicle.bookValues, fimenu.inventoryType, handleAddBookValuePrePostFunction);

				break;
			default:
				break;
		}
	}

	function handleEditBookValue({ row, bookValue }: IBookValueContent) {
		switch (row) {
			case 'Vehicle Values':
				// Opens a modal to create a book value for the specified vehicle.
				editBookValue(fimenu.vehicle.bookValues, fimenu.inventoryType, [bookValue.source], true, handleAddBookValuePrePostFunction);
				break;
			default:
				break;
		}
	}

	function addEditFinanceChargeFee(fee: FIMenuBuyersOrderFee) {
		$modal.open(modalAddEditFinanceChargeFee, {
			name: 'modalAddEditFinanceChargeFee',
			backdrop: false,
			fimenu,
			fee,
			bo,
			isDealLocked: fimenu.isDealLocked(),
			isModalDisabled: fimenu.isDealLocked() || fimenu.isDealPassedFinance() || fimenu.isSpectator,
			postFunction: (updatedFee: FIMenuBuyersOrderFee) => {
				bo.value.upsertFinanceChargeFee(updatedFee);
				loadData(fimenu.isDealLocked());
				saveLockedDeal();
			},
		});
	}

	async function addEditItem(bucketContent: IBucketContent) {
		const { bucketItem, parentBucket } = bucketContent;
		let store = fimenu.store;

		let paymentMethods = new PaymentMethodEnumsHelper().enumList;

		//update with overrides
		if (!bucketItem) {
			isBusyAddEdit.value = true;
			if (parentBucket.bucketType.toLowerCase() == 'cash down') {
				const settingsOptions = settings.lookups.paymentMethods;
				//this is overkill for now as it takes time to eval and reload and we currently don't have a use case
				//let response = await api.settings.getGlobalSettings(JSON.stringify({ fimenu: fimenu.getSanitizedData() }))
				//settingsOptions = response.data.lookups.paymentMethods

				paymentMethods = paymentMethods.filter(pm => settingsOptions.includes(pm.value));
			} else {
				const response = await api.settings.getStore(fimenu.storeCode, JSON.stringify({ fimenu: fimenu.getSanitizedData() }));
				store = new StoreClass(response.data);
			}
			isBusyAddEdit.value = false;
		}

		const isDealLocked = fimenu.isDealLocked();
		const isAdjustment = parentBucket.bucketType === 'Adjustments';

		let storeFees = store.defaultFees;
		let storeAdditions = store.additions.filter(addition => {
			if (isAdjustment) return addition.isAdjustment;
			else return !addition.isAdjustment;
		});
		let storeRebates = store.rebates;

		// If customer has selected coverage, we filter out items that would change the amount they are paying.
		if (isDealLocked) {
			storeFees = storeFees.filter(fee => fee.amount === 0);
			storeAdditions = storeAdditions.filter(addition => addition.price === 0);
			storeRebates = storeRebates.filter(rebate => rebate.amount === 0);
		}

		switch (parentBucket.bucketType.toLowerCase()) {
			case 'fees': {
				$modal.open(modalAddEditFee, {
					name: 'modalAddEditFee',
					backdrop: false,
					bo,
					storeFees,
					bucketContent,
					isDealLocked,
					postFunction: (updatedBO: FIMenuBuyersOrder) => {
						fimenu.upsertBuyersOrder(updatedBO);
						loadData(fimenu.isDealLocked());
						saveLockedDeal();
					},
					isModalDisabled: fimenu.isDealFinalized() || fimenu.isSpectator,
				});
				break;
			}
			case 'additions':
			case 'adjustments': {
				$modal.open(modalAddEditAddition, {
					name: 'modalAddEditAddition',
					backdrop: false,
					fimenu,
					bo,
					storeAdditions,
					bucketContent,
					isDealLocked,
					postFunction: (updatedBO: FIMenuBuyersOrder) => {
						fimenu.upsertBuyersOrder(updatedBO);
						loadData(fimenu.isDealLocked());
						saveLockedDeal();
					},
					isModalDisabled: fimenu.isDealFinalized() || fimenu.isSpectator || (isAdjustment && !isUserInAccounting.value),
				});
				break;
			}
			case 'rebates': {
				$modal.open(modalAddEditRebate, {
					name: 'modalAddEditRebate',
					backdrop: false,
					bo,
					storeRebates,
					bucketContent,
					isDealLocked,
					postFunction: (updatedBO: FIMenuBuyersOrder) => {
						fimenu.upsertBuyersOrder(updatedBO);
						loadData(fimenu.isDealLocked());
						saveLockedDeal();
					},
					isModalDisabled: fimenu.isDealPassedFinance() || fimenu.isSpectator,
				});
				break;
			}
			case 'cash down': {
				$modal.open(modalAddEditDownPayment, {
					name: 'modalAddEditDownPayment',
					backdrop: false,
					bo,
					fimenu,
					paymentMethods,
					bucketContent,
					postFunction: (updatedBO: FIMenuBuyersOrder) => {
						fimenu.upsertBuyersOrder(updatedBO);
						loadData(fimenu.isDealLocked());
						saveLockedDeal();
					},
					isModalDisabled: fimenu.isDealPassedFinance() || fimenu.isSpectator,
				});
				break;
			}
			case 'products': {
				$modal.open(modalAddEditPreloads, {
					name: 'modalAddEditPreloads',
					backdrop: false,
					bo,
					fimenu: fimenu,
					bucketContent,
					isModalDisabled: fimenu.isSpectator,
				});
				break;
			}
		}
	}

	function addEditTaxLine(taxLine?: FIMenuBuyersOrderTaxGroup) {
		$modal.open(modalAddEditTaxLine, {
			name: 'modalAddEditTaxLine',
			backdrop: false,
			bo,
			fimenu,
			taxLine,
			postFunction: (updatedBO: FIMenuBuyersOrder) => {
				// eslint-disable-next-line no-console
				console.log('updatedBO', updatedBO);
				fimenu.upsertBuyersOrder(updatedBO);
				loadData();
			},
			isModalDisabled: fimenu.isDealLocked() || fimenu.isDealPassedFinance(),
		});
	}

	async function addEditFunding(funding: FIMenuFunding = null) {
		isBusyAddEdit.value = true;
		let store = fimenu.store;
		if (funding == null) {
			const response = await api.settings.getStore(fimenu.storeCode, JSON.stringify({ fimenu: fimenu.getSanitizedData() }));
			store = new StoreClass(response.data);
		}
		isBusyAddEdit.value = false;
		$modal.open(modalAddEditFunding, {
			name: 'modalAddEditFunding',
			backdrop: false,
			fimenu: fimenu,
			passedFunding: funding,
			storeFundings: store.fundings,
			postFunction: (response: { funding: FIMenuFunding; isDelete: boolean }) => {
				if (response.isDelete) {
					fimenu.removeFunding(response.funding.id);
				} else {
					fimenu.upsertFunding(response.funding);
				}
				loadData();
				saveLockedDeal();
			},
			isModalDisabled: settings.permissions.hasPositionType(SaturnPermissions.Accounting, user.PositionCode),
		});
	}

	async function dealTypeChanged() {
		EventBus.emit('FIMenu:DealTypeChanged');

		await reset();
	}

	async function reset() {
		await buyersOrderHelper.resetBuyersOrderAsync(fimenu);
	}

	function recalculateDebounced(recalcProfits = false) {
		if (!bo.value.isError()) {
			const coverageTerm = fimenu.getSelectedCoverageTerm();
			let dealTerm = fimenu.getSelectedDealTerm() ?? fimenu.getFirstDealTerm();
			const lender = $global.Lenders.find(lender => lender.lenderCode === fimenu.lender?.lenderCode)?.getStateVersion(fimenu.store.storeState);
			//FOR LEASE, SINCE NOW WE HAVE A BUYERS ORDER RIGHT NEXT TO TERMS
			//WE USE THE FIRST DEAL TERM AS THE "SELECTED" DEAL TERM
			if (fimenu.dealType == 'Lease' && !dealTerm) {
				dealTerm = fimenu.getFirstDealTerm();
			}

			if (recalcProfits) {
				bo.value.recalculateBuyersOrderProfits();
			} else {
				bo.value.recalculateBuyersOrder(fimenu, dealTerm, coverageTerm, lender, 'FINAL');

				if (bo.value.isValid() && bo.value.areAllBucketsValid()) {
					fimenu.otdBase = bo.value.acceptDeclineBuyersOrder?.finalNumbers?.total; // without preloads + doc stamps
					fimenu.otd = bo.value.baseBuyersOrder?.finalNumbers?.total; // with preloads + doc stamps
					fimenu.otdFinal = bo.value.finalNumbers.total;
					EventBus.emit('recalculate');
				}
			}
		}
	}

	function recalculate(recalcProfits = false, debounce = true) {
		if (debounce) {
			util.debounce(recalculateDebounced, 500, recalcProfits);
		} else {
			recalculateDebounced(recalcProfits);
		}
	}

	function loadData(recalcProfits = false) {
		const currentBuyersOrder = fimenu.getCurrentBuyersOrder();

		if (currentBuyersOrder) {
			bo.value = currentBuyersOrder;

			if (!fimenu.isDealLocked() || recalcProfits) {
				recalculate(recalcProfits, false);
			}
		} else {
			console.error('COULD NOT FIND BUYERS ORDER');
			reset();
		}
	}

	function saveLockedDeal(isInvalid = false) {
		if (!isInvalid && fimenu.isDealLocked()) {
			fimenu.save();
		}
	}

	const validations = computed(() => ({
		bo: {
			sellingPrice: {
				required,
				minValue: minValue(0),
			},
			invoiceAmount: {
				required,
				minValue: minValue(0),
			},
			errorCode: {
				isValid: () => !bo.value.errorCode,
			},
		} as any,
	}));

	const v$ = useVuelidate(validations, { bo });
	defineExpose({ recalculate });
</script>
<style>
	.panel-buyers-order {
		z-index: 0;
	}

	.panel-buyers-order .deal-type-dropdown {
		min-width: 100px;
	}

	.panel-buyers-order .panel-body .loading-saturn-anim.fade-in.IsBusySectionComponent-container {
		height: 100%;
		padding: 0;
	}

	.panel-buyers-order.panel {
		border-top: unset;
		height: 100%;
	}

	.panel-buyers-order > .panel-header {
		top: -5px;
		border-top: 1px solid var(--border-color);
	}

	.buyers-order-row {
		align-items: center;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	span.buyers-order-upfront-capped-icon {
		font-size: 19px;
		display: inline-block;
	}

	.buyers-order-upfront-capped-icon:hover {
		cursor: default;
	}

	.buyers-order-grid .no-content {
		align-items: center;
		grid-template-columns: 1fr;
		padding: 10px 0;
	}

	.buyers-order-grid .thick-border-bottom,
	.buyers-order-grid .thick-border-top {
		border-color: var(--main-color);
		border-style: solid;
	}

	.buyers-order-grid .thick-border-bottom {
		border-width: 0 0 2px 0;
		margin-bottom: 10px !important;
		margin-top: -10px;
	}

	.buyers-order-grid .thick-border-top {
		border-width: 2px 0 0 0;
		margin-top: 10px !important;
	}

	.buyers-order-row.total-values {
		border-top: 1px solid var(--panelbuyersorder-grid-color-border);
		font-weight: 600;
		background-color: var(--panelbuyersorder-grid-background-color);
		margin: 0 -10px -10px;
		padding: 12px 10px 12px 10px;
	}

	.buyers-order-row > .pad-left {
		padding-left: 40px;
	}

	.buyers-order-row.subtotal,
	.buyers-order-row.subtotal input {
		font-weight: bold;
	}

	.buyers-order-row.subtotal {
		border-top: 2px solid var(--panelbuyersorder-grid-color-border);
		border-bottom: 2px solid var(--panelbuyersorder-grid-color-border);
		margin-bottom: -2px;
	}

	.buyers-order-row.preloads-list {
		border: none;
	}

	.buyers-order-row.product-list {
		border: none;
	}

	.buyers-order-row .preloaded-question {
		padding-right: 5px;
	}

	.buyers-order-content {
		position: relative;
		z-index: 100;
	}

	.buyers-order-error {
		height: 400px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	.buyers-order-error-title {
		font-size: 35px;
		font-weight: bold;
		color: var(--error-color);
	}

	.buyers-order-error-subtitle {
		font-size: 15px;
		color: var(--black-70percent);
	}

	.buyers-order-error-code {
		margin-top: 30px;
		font-weight: bold;
		color: var(--error-color);
	}

	.buyers-order-error-message {
		color: var(--error-color);
	}

	.new-tax-line {
		margin-left: 10px;
	}

	.panel-buttons .button-edit {
		display: flex;
		flex: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		height: 25px;
		padding: 0px 10px;
		width: 100%;
	}

	.panel-buyers-order .panel-buttons .InputDropdown {
		width: 120px;
	}

	.new-tax-line button.button.button-edit {
		height: 25px;
		padding: 0px 10px;
	}

	.buyers-order-error-actions {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 315px;
	}

	.bo-transaction-id {
		margin-right: 10px;
		min-width: 310px;
		text-align: end;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.bo-transaction-id .bo-transaction-active,
	.bo-transaction-id .bo-transaction-last {
		display: flex;
		gap: 5px;
		width: fit-content;
	}

	.bo-transaction-id .bo-transaction-active {
		font-size: 15px;
	}

	.bo-transaction-id .bo-transaction-last {
		font-size: 13px;
		color: var(--third-color);
	}

	.bo-transaction-id .bo-transaction-id-title {
		font-weight: 600;
	}

	.buyers-order-column-headers {
		font-weight: bold;
		text-align: right;
		margin-top: 15px;
	}

	.subtotal-container > div,
	span.subtotal-container,
	.subtotal-container .span,
	.subtotal-container input {
		font-weight: bold;
		color: var(--panelbuyersorder-grid-text-color);
	}

	.bo-placeholder {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		align-items: center;
		color: var(--error-color);
	}

	.panel-buyers-order .flex-side-by-side {
		gap: 5px !important;
	}

	.buyers-order-row .align-right {
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
</style>
